import { accountApi } from '@/api/accountApi'
import { subscriptionApi } from '@/api/subscriptionApi'
import { normalizeApiPermissions } from '@/permissions/normalizeApiPermissions'
import { PermissionsMap } from '@/types/permissions'
import { Subscription, SubscriptionStatus } from '@/types/subscription'
import { User } from '@/types/user'
import { WorkspaceMember } from '@/types/workspace'

export type UserSession = {
  user: User
  permissions: PermissionsMap
  workspaceMemberships: WorkspaceMember[]
  subscriptions: Subscription[]
}

export const getUserSession = async (): Promise<UserSession> => {
  const { user } = await accountApi.whoAmI()

  const [workspaceMemberships, subscriptions] = await Promise.all([
    accountApi.getMyWorkspaceMemberships(),
    subscriptionApi.getSubscriptions({
      status: SubscriptionStatus.Active,
      ordering: '-created_at' // newest first
    })
  ])

  return {
    user,
    permissions: normalizeApiPermissions(user.workspace_permissions),
    workspaceMemberships,
    subscriptions: subscriptions.results
  }
}
